import { h } from 'preact'
import { IMatchesByDay } from '../../lib/model'
import styles from './MatchesSection.module.css'
import { MatchResult } from '../MatchResult/MatchResult'
import { MatchStatus } from '../MatchStatus/MatchStatus'
import { MatchTeams } from '../MatchTeams/MatchTeams'
import { useEffect, useState } from 'preact/hooks'

const nrkCalendar = require('../../static/nrk-calendar.svg').default
interface Props {
  matches: IMatchesByDay
}

export function MatchesSection(props: Props) {
  const [todayElement, setTodayElement] = useState<HTMLTimeElement | null>(null)
  const [coreScrollEl, setCoreScrollEl] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    const nodes = coreScrollEl?.childNodes
    let marginOffset = 0.0
    let tmpCounter = 0
    nodes?.forEach((node) => {
      if (node.nodeName === 'TIME') {
        tmpCounter++
      }
      if (node === todayElement) {
        marginOffset = tmpCounter * 4 // 4 chosen by trial
      }
    })

    if (todayElement) {
      const scrollX = todayElement.offsetLeft - marginOffset // margin
      coreScrollEl.scroll(scrollX, 0)
    }
  }, [coreScrollEl, todayElement])

  return (
    <div class={styles['dh-fotball-banner__matchesSection']}>
      <div
        ref={setCoreScrollEl}
        class={styles['dh-fotball-banner__scrollItemsWrapper']}
        id={'scroll'}
      >
        {collectElementsList(props.matches, setTodayElement)}
      </div>
    </div>
  )
}

const isToday = (matchDateStr) => {
  const matchDate = new Date(matchDateStr)
  const today = new Date()
  return (
    matchDate.getDate() === today.getDate() &&
    matchDate.getMonth() === today.getMonth() &&
    matchDate.getFullYear() === today.getFullYear()
  )
}

const MONTHS = [
  'jan.',
  'feb.',
  'mars',
  'april',
  'mai',
  'juni',
  'juli',
  'aug.',
  'sept.',
  'okt.',
  'nov.',
  'des.',
]

function formatDate(matchDate) {
  if (!matchDate) {
    return matchDate
  }
  const date = new Date(matchDate)
  return `${date.getDate()}. ${MONTHS[date.getMonth()]}`
}

export function collectElementsList(matches: IMatchesByDay, setTodayElement) {
  const elementsList = []
  Object.keys(matches).forEach((matchDay) => {
    if (isToday(matchDay)) {
      const timeElement: h.JSX.Element = (
        <time
          ref={setTodayElement}
          dateTime={matchDay}
          class={`${styles['dh-fotball-banner__matches-date']}`}
          style={`background-image: url(${nrkCalendar});`}
        >
          {formatDate(matchDay)}
        </time>
      )
      elementsList.push(timeElement)
    } else {
      const timeElement = (
        <time
          dateTime={matchDay}
          class={`${styles['dh-fotball-banner__matches-date']}`}
          style={`background-image: url(${nrkCalendar});`}
        >
          {formatDate(matchDay)}
        </time>
      )
      elementsList.push(timeElement)
    }

    matches[matchDay].forEach((matchData) => {
      const matchElement = (
        <div class={`${styles['dh-fotball-banner__match-details']}`}>
          <MatchStatus matchData={matchData} />
          <MatchResult result={matchData.result} />
          <MatchTeams matchData={matchData} />
        </div>
      )
      elementsList.push(matchElement)
    })
  })

  return elementsList
}
